module.exports = __webpack_public_path__ + "static/img/addrestroom.2bcc89d.png";